import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './page.module.css';
import Head from './Head';
import Section from './Section';

const Page = (props) => {
  const {
    title,
    children,
    isFull = false,
    backgroundImage,
  } = props;

  const classNames = clsx(
    classes.page,
    isFull && classes.full,
    backgroundImage && classes.withBackground,
  );

  const style = backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`,
  } : {};

  return (
    <div className={classNames} style={style}>
      <Head title={title} />
      {children}
    </div>
  );
};

Page.Section = Section;

Page.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  isFull: PropTypes.bool,
  backgroundImage: PropTypes.string,
};

export default Page;
